import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ShopServiceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ShopServiceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.8345 22.0002H5.16554C3.73048 22.0002 2.56301 20.8322 2.56301 19.3977V10.9817C2.56301 10.7053 2.78664 10.4817 3.06301 10.4817C3.33938 10.4817 3.56301 10.7053 3.56301 10.9817V19.3977C3.56301 20.2815 4.28175 21.0002 5.16554 21.0002H18.8345C19.7183 21.0002 20.437 20.2815 20.437 19.3977V10.9817C20.437 10.7053 20.6607 10.4817 20.937 10.4817C21.2134 10.4817 21.437 10.7053 21.437 10.9817V19.3977C21.437 20.8322 20.2695 22.0002 18.8345 22.0002Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3731 11.7571C18.3501 11.7571 17.4468 11.2346 16.9155 10.4436C16.3843 11.2346 15.4805 11.7571 14.4575 11.7571C13.4346 11.7571 12.5313 11.2346 12 10.4436C11.4688 11.2346 10.5654 11.7571 9.54249 11.7571C8.51954 11.7571 7.61573 11.2346 7.08448 10.4436C6.55323 11.2346 5.64991 11.7571 4.62696 11.7571C2.9961 11.7571 1.66895 10.4299 1.66895 8.79905C1.66895 8.74534 1.67774 8.69163 1.69483 8.64085L3.79787 2.34202C3.86574 2.13792 4.05665 2.00022 4.27199 2.00022H19.728C19.9434 2.00022 20.1343 2.13792 20.2022 2.34202L22.3047 8.64085C22.3218 8.69163 22.3306 8.74534 22.3306 8.79905C22.3306 10.4299 21.0039 11.7571 19.3731 11.7571ZM17.4155 8.79905C17.4155 9.87913 18.2935 10.7571 19.3731 10.7571C20.4268 10.7571 21.2886 9.92015 21.3291 8.8762L19.3677 3.00022H4.63234L2.67043 8.8762C2.71096 9.92015 3.57326 10.7571 4.62697 10.7571C5.70655 10.7571 6.58449 9.87913 6.58449 8.79905C6.58449 8.52268 6.80812 8.29905 7.08449 8.29905C7.36086 8.29905 7.58449 8.52268 7.58449 8.79905C7.58449 9.87913 8.4629 10.7571 9.54249 10.7571C10.6221 10.7571 11.5 9.87913 11.5 8.79905C11.5 8.52268 11.7236 8.29905 12 8.29905C12.2764 8.29905 12.5 8.52268 12.5 8.79905C12.5 9.87913 13.3779 10.7571 14.4575 10.7571C15.5371 10.7571 16.4155 9.87913 16.4155 8.79905C16.4155 8.52268 16.6392 8.29905 16.9155 8.29905C17.1919 8.29905 17.4155 8.52268 17.4155 8.79905Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 9.29905C11.7236 9.29905 11.5 9.07542 11.5 8.79905V2.50022C11.5 2.22385 11.7236 2.00022 12 2.00022C12.2764 2.00022 12.5 2.22385 12.5 2.50022V8.79905C12.5 9.07542 12.2764 9.29905 12 9.29905Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.08498 9.29905C7.05764 9.29905 7.02932 9.2971 7.001 9.29221C6.72903 9.24631 6.54543 8.98752 6.59133 8.71604L7.65676 2.41721C7.70315 2.14475 7.95656 1.95725 8.23342 2.00705C8.50539 2.05295 8.68899 2.31174 8.64309 2.58322L7.57766 8.88205C7.53616 9.12619 7.32473 9.29905 7.08498 9.29905Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.8682 9.29905C16.6284 9.29905 16.417 9.1262 16.3755 8.88206L15.3096 2.58323C15.2637 2.31175 15.4473 2.05296 15.7192 2.00706C15.9907 1.95921 16.2495 2.14378 16.2959 2.41722L17.3618 8.71605C17.4077 8.98753 17.2241 9.24632 16.9522 9.29222C16.9238 9.2971 16.896 9.29905 16.8682 9.29905Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8184 22.0002H9.18116C8.90479 22.0002 8.68116 21.7766 8.68116 21.5002V15.1955C8.68116 14.3401 9.37697 13.6447 10.2324 13.6447H13.7671C14.6226 13.6447 15.3184 14.3401 15.3184 15.1955V21.5002C15.3184 21.7766 15.0947 22.0002 14.8184 22.0002ZM9.68116 21.0002H14.3184V15.1955C14.3184 14.8918 14.0713 14.6447 13.7671 14.6447H10.2324C9.92824 14.6447 9.68116 14.8918 9.68116 15.1955V21.0002Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ShopServiceIcon;
